// src/api/authApi.js
import api from './axios';

export const authApi = {

  /** Register a new customer */
  register: (data) =>
    api.post('/auth/register', data).then(r => r.data),

  /** Login → returns { token, user } */
  login: (email, password) =>
    api.post('/auth/login', { email, password }).then(r => r.data),

  /** Sign in with Google — exchange a GIS ID token for our session */
  google: (credential) =>
    api.post('/auth/google', { credential }).then(r => r.data),

  /** Phone OTP login — step 1: send code */
  otpSend: (phone) =>
    api.post('/auth/otp/send', { phone }).then(r => r.data),

  /** Phone OTP login — resend code */
  otpResend: (phone) =>
    api.post('/auth/otp/resend', { phone }).then(r => r.data),

  /** Phone OTP login — step 2: verify → returns { token, user } */
  otpVerify: (phone, otp) =>
    api.post('/auth/otp/verify', { phone, otp }).then(r => r.data),

  /** Which login methods are live (e.g. { otp: false } until MSG91 is configured) */
  getMethods: () =>
    api.get('/auth/methods').then(r => r.data),

  /** Silent token refresh (uses httpOnly cookie) */
  refresh: () =>
    api.post('/auth/refresh').then(r => r.data),

  /** Logout — clears cookie server-side */
  logout: () =>
    api.post('/auth/logout').then(r => r.data),

  /** Get current user profile + populated wishlist */
  getMe: () =>
    api.get('/auth/me').then(r => r.data),

  /** Update name / phone */
  updateProfile: (data) =>
    api.put('/auth/me', data).then(r => r.data),

  /** Change password */
  changePassword: (currentPassword, newPassword) =>
    api.put('/auth/password', { currentPassword, newPassword }).then(r => r.data),

  /** Add a delivery address */
  addAddress: (address) =>
    api.post('/auth/addresses', address).then(r => r.data),

  /** Delete an address by id */
  deleteAddress: (id) =>
    api.delete(`/auth/addresses/${id}`).then(r => r.data),

  /** Toggle wishlist — returns { action: 'added'|'removed', wishlist } */
  toggleWishlist: (productId) =>
    api.post(`/auth/wishlist/${productId}`).then(r => r.data),
};
